<template>
  <v-dialog
    :value="visible"
    max-width="460"
    content-class="lafia-inapp-dialog"
    overlay-color="#25191c"
    :overlay-opacity="0.68"
    @input="handleVisibility"
  >
    <section class="royal-card" role="dialog" aria-modal="true" aria-labelledby="inapp-dialog-title" :lang="languageCode">
      <div class="royal-card__inner">
        <div class="royal-emblem" aria-hidden="true">
          <img src="@/assets/deco/inapp-royal-emblem-transparent.png" alt="" class="royal-emblem__castle" />
        </div>

        <div class="royal-wordmark" aria-hidden="true">
          <span></span>
          <b>THE LAFIA KINGDOM</b>
          <span></span>
        </div>

        <template v-if="!showGuide">
          <p class="royal-kicker">{{ $t("dialog.inweb-kicker") }}</p>
          <h2 id="inapp-dialog-title" class="royal-title">{{ $t("dialog.inweb-title") }}</h2>
          <p class="royal-note">{{ $t("dialog.inweb-note") }}</p>

          <button type="button" class="royal-primary" @click="showGuide = true">
            {{ $t("dialog.inweb-open-guide") }}
          </button>
          <button type="button" class="royal-secondary" @click="confirmClick">
            {{ $t("dialog.inweb-dismiss") }}
          </button>
        </template>

        <template v-else>
          <p class="royal-kicker">{{ $t("dialog.inweb-guide-kicker") }}</p>
          <h2 id="inapp-dialog-title" class="royal-title royal-title--guide">{{ $t("dialog.inweb-open-guide") }}</h2>
          <p class="royal-guide">{{ $t("dialog.inweb-guide") }}</p>

          <button type="button" class="royal-primary" @click="confirmClick">
            {{ $t("dialog.inweb-guide-close") }}
          </button>
          <button type="button" class="royal-secondary" @click="showGuide = false">
            {{ $t("dialog.inweb-guide-back") }}
          </button>
        </template>
      </div>
    </section>
  </v-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    showGuide: false,
  }),

  computed: {
    languageCode() {
      return this.$i18n.locale === "jp" ? "ja" : this.$i18n.locale
    },
  },

  watch: {
    visible(value) {
      if (!value) this.showGuide = false
    },
  },

  methods: {
    handleVisibility(value) {
      this.$emit("input", value)
    },

    confirmClick() {
      this.showGuide = false
      this.$emit("confirm")
    },
  },
}
</script>
<style scoped>
::v-deep .lafia-inapp-dialog {
  margin: 12px;
  overflow: visible;
  box-shadow: none;
}

.royal-card {
  position: relative;
  width: 100%;
  max-height: calc(100vh - 92px);
  margin-top: 68px;
  overflow: visible;
  padding: 9px;
  color: #493a35;
  background: #fffaf1;
  border: 1px solid #d4ad68;
  border-radius: 28px;
  box-shadow:
    0 24px 58px rgba(31, 19, 20, 0.34),
    0 4px 12px rgba(31, 19, 20, 0.18);
  isolation: isolate;
}

.royal-card::before,
.royal-card__inner::before {
  content: "";
  position: absolute;
  left: 13%;
  width: 74%;
  background: inherit;
  border: inherit;
  border-bottom: 0;
  border-radius: 50% 50% 0 0 / 100% 100% 0 0;
}

.royal-card::before {
  z-index: 0;
  top: -68px;
  height: 78px;
}

.royal-card::after,
.royal-card__inner::after {
  content: "";
  position: absolute;
  left: 13%;
  width: 74%;
  height: 12px;
  background: inherit;
}

.royal-card::after {
  z-index: 1;
  top: -1px;
}

.royal-card__inner {
  position: relative;
  z-index: 2;
  min-height: 540px;
  padding: 8px 36px 28px;
  text-align: center;
  background: #fffaf3;
  border: 1px solid rgba(194, 144, 66, 0.82);
  border-radius: 21px;
}

.royal-card__inner::before {
  z-index: 0;
  top: -59px;
  height: 68px;
}

.royal-card__inner::after {
  z-index: 1;
  top: -1px;
}

.royal-card__inner > * {
  position: relative;
  z-index: 2;
}

.royal-emblem {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 158px;
  margin-top: -48px;
}

.royal-emblem__castle {
  display: block;
  width: 230px;
  max-width: 78%;
  height: auto;
  mix-blend-mode: multiply;
}

.royal-wordmark {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  margin: 2px auto 28px;
  color: #a77a39;
}

.royal-wordmark span {
  width: 38px;
  height: 1px;
  background: #d2aa68;
}

.royal-wordmark b {
  font-family: Georgia, "Times New Roman", serif;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.18em;
  white-space: nowrap;
}

.royal-kicker {
  margin: 0 0 18px;
  color: #a34054;
  font-family: "Cafe24Danjunghae", "NanumSquare", serif;
  font-size: clamp(26px, 8vw, 38px);
  line-height: 1.25;
  word-break: keep-all;
}

.royal-title {
  margin: 0;
  color: #3f342f;
  font-family: "Cafe24Danjunghae", "NanumSquare", serif;
  font-size: clamp(27px, 7vw, 34px);
  font-weight: 400;
  line-height: 1.35;
  word-break: keep-all;
}

.royal-title--guide {
  font-size: clamp(25px, 6.8vw, 32px);
}

.royal-note,
.royal-guide {
  margin: 18px 0 28px;
  color: #645652;
  font-family: "NanumSquare", sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 1.6;
  word-break: keep-all;
}

.royal-guide {
  min-height: 82px;
}

.royal-primary,
.royal-secondary {
  width: 100%;
  font-family: "Cafe24Danjunghae", "NanumSquare", serif;
  cursor: pointer;
}

.royal-primary {
  min-height: 64px;
  padding: 14px 18px;
  color: #fffdf8;
  background: #b85569;
  border: 2px solid #c9945b;
  border-radius: 13px;
  box-shadow:
    inset 0 0 0 2px rgba(255, 236, 196, 0.42),
    0 8px 16px rgba(117, 42, 59, 0.2);
  font-size: 24px;
  line-height: 1.25;
}

.royal-primary:focus-visible,
.royal-secondary:focus-visible {
  outline: 3px solid rgba(184, 85, 105, 0.32);
  outline-offset: 3px;
}

.royal-secondary {
  min-height: 48px;
  margin-top: 14px;
  padding: 8px 16px;
  color: #594b46;
  background: transparent;
  border: 0;
  border-bottom: 1px solid rgba(198, 153, 78, 0.58);
  font-size: 19px;
  line-height: 1.25;
}

[lang="ja"] .royal-kicker,
[lang="ja"] .royal-title,
[lang="ja"] .royal-primary,
[lang="ja"] .royal-secondary {
  font-family: "GN-Kin-iro_SansSerif", "NanumSquare", sans-serif;
}

@media (max-width: 420px) {
  .royal-card {
    padding: 7px;
    border-radius: 24px;
  }

  .royal-card__inner {
    min-height: 500px;
    padding: 6px 24px 22px;
    border-radius: 18px;
  }

  .royal-emblem {
    height: 145px;
    margin-top: -44px;
  }

  .royal-emblem__castle {
    width: 210px;
  }

  .royal-wordmark {
    gap: 9px;
    margin-bottom: 22px;
  }

  .royal-wordmark span {
    width: 22px;
  }

  .royal-wordmark b {
    font-size: 11px;
    letter-spacing: 0.14em;
  }

  .royal-kicker {
    margin-bottom: 14px;
  }

  .royal-note,
  .royal-guide {
    margin: 15px 0 22px;
    font-size: 15px;
  }

  .royal-primary {
    min-height: 58px;
    font-size: 21px;
  }

  .royal-secondary {
    min-height: 42px;
    margin-top: 10px;
    font-size: 17px;
  }
}

.royal-note {
  white-space: pre-line;
}

@media (max-height: 680px) {
  .royal-card__inner {
    min-height: auto;
    padding-top: 4px;
  }

  .royal-emblem {
    height: 125px;
    margin-top: -40px;
  }

  .royal-emblem__castle {
    width: 182px;
  }

  .royal-wordmark {
    margin-bottom: 16px;
  }
}
</style>
